import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { adminInstance } from "../../config/axios";
import { Button, Label, Form, FormGroup } from "reactstrap";
import { getAdminData } from "../../reducers/adminReducers";

const MaintenanceMode = () => {
  const initialChance = {
    isEnabled: false,
  };
  const dispatch = useDispatch();
  const result = useSelector((state) => state.admin);
  const { maintenaceMode: maintence } = result || {};
  const [maintenanceMode, setMaintenanceMode] = useState(initialChance);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (maintence) {
      setMaintenanceMode({
        isEnabled: maintence,
      });
    }
  }, [maintence]);

  const onSubmitHandleData = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      const payload = {
        isEnabled: maintenanceMode?.isEnabled,
      };
      const response = await adminInstance().post(
        "/api/admin/updateMaintenanceMode",
        payload,
      );
      const { code, message } = response.data;
      if (code === 200) {
        toast.success(message);
        dispatch(getAdminData());
      } else {
        toast.error(message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleMaintenanceModeVisibility = (e, p) => {
    const { name } = e.target;
    setMaintenanceMode({ ...maintenanceMode, [name]: p });
  };
  return (
    <>
      <Form className="needs-validation user-add" onSubmit={onSubmitHandleData}>
        <FormGroup className="row justify-content-start mx-0">
          <div className="admin-input col-xl-5 col-md-7">
            <Label className="col-form-label pt-0">Maintenance Mode</Label>
            <Label className="d-block hide_show">
              <input
                className="radio_animated"
                id="edo-ani"
                type="radio"
                name="isEnabled"
                defaultValue={maintenanceMode?.isEnabled || false}
                checked={maintenanceMode?.isEnabled === true ? true : false}
                onChange={(e) => handleMaintenanceModeVisibility(e, true)}
              />
              Show
            </Label>
            <Label className="d-block hide_show">
              <input
                className="radio_animated"
                id="edo-ani1"
                type="radio"
                name="isEnabled"
                checked={maintenanceMode?.isEnabled === false ? true : false}
                defaultValue={maintenanceMode?.isEnabled || false}
                onChange={(e) => handleMaintenanceModeVisibility(e, false)}
              />
              Hide
            </Label>
            {/* <p className="text-danger">{emptyError || ''}</p> */}
          </div>
        </FormGroup>
        <div className="form-button d-flex justify-content-start pt-3">
          <Button
            disabled={isLoading || maintenanceMode?.isEnabled === maintence}
            type="submit"
            color="primary"
            className="main-btn">
            Update
          </Button>
        </div>
      </Form>
    </>
  );
};

export default MaintenanceMode;
